import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { formValueSelector, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ASSIGN_ENTITIES_FORM_NAME } from 'Common/FormEnum';
import { AssignEntitiesEnum, FilterEnum } from 'Common/FieldEnum';
import { errorToast } from 'Common/ToastHelper';
import { CheckboxField, SelectField } from 'Common/SemanticWrapper';
import * as FilterSelectors from 'State/filters/selectors';

import AssignItemToSitesComponent from '../../components/assignEntities/AssignItemToSites';
import AssignSiteToItemsComponent from '../../components/assignEntities/AssignSiteToItems';
import SiteGroupsToItemsComponent from '../../components/assignEntities/AssignSiteGroupsToItems';
import AssignItemToSiteGroups from '../../components/assignEntities/AssignItemToSiteGroups';
import AssignSiteToUsers from '../../components/assignEntities/AssignSiteToUsers';
import AssignSiteGroupToUsers from '../../components/assignEntities/AssignSiteGroupToUsers';
import AssignUserToSites from '../../components/assignEntities/AssignUserToSites';
import AssignUserToSiteGroups from '../../components/assignEntities/AssignUserToSiteGroups';
import {
  ComponentMapping,
  getComponentOnSelection,
  GridNames,
  GridResetInitialValueEnum,
  INITIAL_VALUES,
} from '../../../helper/assignEntities';
import {
  clearItemGridFilter,
  clearSubmitError,
} from '../../../state/assignEntities/actions';
import { AssignOrderingSiteHeaderContainer } from './AssignOrderingSiteHeader';
import * as Selectors from '../../../state/assignEntities/selectors';

import 'Styles/pages/utilities/assignentities/index.less';

class AssignEntities extends Component {
  static propTypes = {
    bidGroupData: PropTypes.array.isRequired,
    itemGroupData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    vendorData: PropTypes.array.isRequired,
    storageLocationData: PropTypes.array.isRequired,
    allSitesData: PropTypes.array.isRequired,
    allItemsData: PropTypes.array.isRequired,
    siteGroupData: PropTypes.array.isRequired,
    allUsersData: PropTypes.array.isRequired,
    resetGridPage: PropTypes.object.isRequired,
    clearSubmitError: PropTypes.func.isRequired,
    clearItemGridFilter: PropTypes.func.isRequired,
    allSitesLoadingError: PropTypes.array,
    allItemsLoadingError: PropTypes.array,
    siteGroupLoadingError: PropTypes.array,
    allUsersLoadingError: PropTypes.array,
    loadingAllSites: PropTypes.bool.isRequired,
    loadingAllItems: PropTypes.bool.isRequired,
    loadingSiteGroup: PropTypes.bool.isRequired,
    loadingAllUsers: PropTypes.bool.isRequired,
    isRightGridFiltered: PropTypes.bool.isRequired,
    sortOptionsValue: PropTypes.string,
    dropDownValue: PropTypes.string,
    setIsReadOnlyState: PropTypes.func,
    onResetPageOnDataChange: PropTypes.func,
    changeDirection: PropTypes.func,
    setSiteGridInstance: PropTypes.func,
    setItemGridInstance: PropTypes.func,
    onFilteredChange: PropTypes.func,
    initialValues: PropTypes.object,
    itemGridInstance: PropTypes.object,
    rightSideGridReactTableRef: PropTypes.object,
    isReadOnly: PropTypes.bool,
    direction: PropTypes.bool,
  };

  static defaultProps = {
    isRightGridFiltered: false,
    isReadOnly: true,
    direction: true,
    itemGridInstance: null,
    rightSideGridReactTableRef: null,
    initialValues: { ...INITIAL_VALUES },
    setIsReadOnlyState: () => {},
    onResetPageOnDataChange: () => {},
    changeDirection: () => {},
    setSiteGridInstance: () => {},
    setItemGridInstance: () => {},
    onFilteredChange: () => {},
    clearSubmitError: () => {},
    clearItemGridFilter: () => {},
    dropDownValue: AssignEntitiesEnum.FoodItems,
    sortOptionsValue: AssignEntitiesEnum.Site,
  };

  fields = [
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: this.props.bidGroupData,
      label: 'BID GROUP',
    },
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: this.props.itemGroupData,
      label: 'ITEM GROUP',
    },
    {
      name: FilterEnum.GroupId_Cat,
      component: SelectField,
      type: 'text',
      options: this.props.acctCategoryData,
      label: 'ACCT. CATEGORY',
    },
    {
      name: FilterEnum.VendorId,
      component: SelectField,
      type: 'text',
      options: this.props.vendorData,
      label: 'DISTRIBUTOR',
    },
    {
      name: FilterEnum.GroupId_Location,
      component: SelectField,
      type: 'text',
      options: this.props.storageLocationData,
      label: 'STORAGE LOCATION',
    },
    {
      name: FilterEnum.PrepareInHouse,
      component: CheckboxField,
      label: 'KITCHEN ITEM',
      toggle: true,
      columnClassName: 'pt-50 kitchen-item-label',
    },
  ];

  state = {
    render: {
      SiteToItemsComponents: true,
      ItemToSitesComponents: false,
      SiteGroupToItemsComponents: false,
      ItemToSiteGroupsComponents: false,
      SiteToUsersComponents: false,
      SiteGroupToUsersComponents: false,
      UserToSitesComponent: false,
      UserToSitesGroupComponents: false,
    },
  };

  componentDidUpdate(prevProps) {
    const { clearSubmitError } = this.props;
    if (
      errorToast(this.props, prevProps, 'allSitesLoadingError') ||
      errorToast(this.props, prevProps, 'siteGroupLoadingError') ||
      errorToast(this.props, prevProps, 'allItemsLoadingError') ||
      errorToast(this.props, prevProps, 'allUsersLoadingError')
    ) {
      clearSubmitError();
    }
  }

  changeGrid = componentName => {
    const obj = {
      ItemToSitesComponents:
        componentName === ComponentMapping.ItemToSitesComponents,
      SiteToItemsComponents:
        componentName === ComponentMapping.SiteToItemsComponents,
      SiteGroupToItemsComponents:
        componentName === ComponentMapping.SiteGroupToItemsComponents,
      ItemToSiteGroupsComponents:
        componentName === ComponentMapping.ItemToSiteGroupsComponents,
      SiteToUsersComponents:
        componentName === ComponentMapping.SiteToUsersComponents,
      SiteGroupToUsersComponents:
        componentName === ComponentMapping.SiteGroupToUsersComponents,
      UserToSitesComponents:
        componentName === ComponentMapping.UserToSitesComponents,
      UserToSiteGroupsComponents:
        componentName === ComponentMapping.UserToSiteGroupsComponents,
    };
    this.setState({ render: obj }, () => {
      this.props.clearItemGridFilter();
      this.props.onFilteredChange([]);
      this.props.onResetPageOnDataChange(GridResetInitialValueEnum);
    });
  };

  handleChange = (e, newValue, prevValue, fieldName) => {
    this.props.change(AssignEntitiesEnum[fieldName], newValue);
  };

  getRenderComponent = () => {
    const {
      SiteToItemsComponents,
      ItemToSitesComponents,
      SiteGroupToItemsComponents,
      ItemToSiteGroupsComponents,
      SiteToUsersComponents,
      SiteGroupToUsersComponents,
      UserToSitesComponents,
      UserToSiteGroupsComponents,
    } = this.state.render;
    const {
      initialValues,
      sortOptionsValue,
      allSitesData,
      loadingAllSites,
      allItemsData,
      loadingAllItems,
      siteGroupData,
      loadingSiteGroup,
      dropDownValue,
      allUsersData,
      loadingAllUsers,
      setIsReadOnlyState,
      isReadOnly,
      setSiteGridInstance,
      setItemGridInstance,
      itemGridInstance,
      rightSideGridReactTableRef,
      resetGridPage,
      onResetPageOnDataChange,
      onFilteredChange,
      isRightGridFiltered,
      direction,
    } = this.props;

    const commonProps = {
      changeGrid: this.changeGrid,
      handleChange: this.handleChange,
      sortOptionsValue,
      dropDownValue,

      allSitesData,
      loadingAllSites,

      loadingAllItems,
      allItemsData,

      loadingSiteGroup,
      siteGroupData,

      allUsersData,
      loadingAllUsers,
      setIsReadOnlyState,
      renderedComponent: this.state.render,
      isReadOnly,
      setSiteGridInstance,
      setItemGridInstance,
      itemGridInstance,
      resetGridPage,
      onResetPageOnDataChange,
      direction,
    };
    if (SiteToItemsComponents) {
      return (
        <AssignSiteToItemsComponent
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          {...commonProps}
        />
      );
    } else if (ItemToSitesComponents) {
      return (
        <AssignItemToSitesComponent
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    } else if (SiteGroupToItemsComponents) {
      return (
        <SiteGroupsToItemsComponent
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          initialValues={initialValues}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    } else if (ItemToSiteGroupsComponents) {
      return (
        <AssignItemToSiteGroups
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    } else if (SiteToUsersComponents) {
      return (
        <AssignSiteToUsers
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    } else if (SiteGroupToUsersComponents) {
      return (
        <AssignSiteGroupToUsers
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    } else if (UserToSitesComponents) {
      return (
        <AssignUserToSites
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    } else if (UserToSiteGroupsComponents) {
      return (
        <AssignUserToSiteGroups
          initialValues={initialValues}
          onFilteredChange={onFilteredChange}
          rightSideGridReactTableRef={rightSideGridReactTableRef}
          isRightGridFiltered={isRightGridFiltered}
          {...commonProps}
        />
      );
    }
  };
  clearFilter = () => {
    //To re-render the page current page even it is site to item page.
    this.setState(
      {
        render: {
          SiteToItemsComponents: false,
          ItemToSitesComponents: false,
          SiteGroupToItemsComponents: false,
          ItemToSiteGroupsComponents: false,
          SiteToUsersComponents: false,
          SiteGroupToUsersComponents: false,
          UserToSitesComponent: false,
          UserToSitesGroupComponents: false,
        },
      },
      () => {
        this.props.clearFilter();
        this.props.clearItemGridFilter();
        this.setState({
          render: { ...this.state.render, SiteToItemsComponents: true },
        });
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
        });
      }
    );
  };

  handleDropDownChange = (e, values) => {
    this.setState({
      filterValues: values,
    });
    const { direction, sortOptionsValue, dropDownValue } = this.props;
    const renderedComponent = getComponentOnSelection(
      sortOptionsValue,
      dropDownValue,
      direction
    );
    if (
      renderedComponent === ComponentMapping.SiteToItemsComponents ||
      renderedComponent === ComponentMapping.SiteGroupToItemsComponents
    ) {
      this.props.onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Site]: false,
      });
    } else if (
      renderedComponent === ComponentMapping.ItemToSitesComponents ||
      renderedComponent === ComponentMapping.ItemToSiteGroupsComponents
    ) {
      this.props.onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Item]: true,
        [GridNames.Site]: false,
      });
    }
  };

  render() {
    const { changeDirection, direction, onResetPageOnDataChange } = this.props;
    return (
      <Form>
        <AssignOrderingSiteHeaderContainer
          changeGrid={this.changeGrid}
          direction={direction}
          changeDirection={changeDirection}
          fields={this.fields}
          clearFilter={this.clearFilter}
          handleDropDownChange={this.handleDropDownChange}
          onResetPageOnDataChange={onResetPageOnDataChange}
        />
        {this.getRenderComponent()}
      </Form>
    );
  }
}

AssignEntities = reduxForm({
  form: ASSIGN_ENTITIES_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AssignEntities);

const selector = formValueSelector(ASSIGN_ENTITIES_FORM_NAME);
const mapStateToProps = state => {
  return {
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    dropDownValue: selector(state, AssignEntitiesEnum.To),

    allSitesData: Selectors.getAllSitesData(state),
    loadingAllSites: Selectors.getLoadingAllSites(state),
    allSitesLoadingError: Selectors.getAllSitesLoadingError(state),

    loadingAllItems: Selectors.getLoadingAllItems(state),
    allItemsData: Selectors.getAllItemsData(state),
    allItemsLoadingError: Selectors.getAllItemsLoadingError(state),

    siteGroupLoadingError: Selectors.getSiteGroupLoadingError(state),
    siteGroupData: Selectors.getSiteGroupData(state),
    loadingSiteGroup: Selectors.getLoadingSiteGroup(state),

    allUsersData: Selectors.getAllUsersData(state),
    loadingAllUsers: Selectors.getLoadingAllUsers(state),
    allUsersLoadingError: Selectors.getAllUsersLoadingError(state),

    bidGroupData: FilterSelectors.selectBidGroupData(state),
    itemGroupData: FilterSelectors.selectItemGroupData(state),
    acctCategoryData: FilterSelectors.selectAcctCategoryData(state),
    vendorData: FilterSelectors.selectVendorData(state),
    storageLocationData: FilterSelectors.selectStorageLocationData(state),
  };
};

const mapDispatchToProps = {
  clearSubmitError,
  clearItemGridFilter,
};

export const AssignEntitiesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignEntities);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/assignEntities/AssignEntities.js